import React, { useCallback, useMemo } from 'react';

import jamespot, { WidgetDisplayMode, WidgetPresenceContent } from 'jamespot-user-api';

import { shallowEqual } from 'react-redux';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

export const CSSPaddingMd = styled.div`
    padding: ${(props) => props.theme.space.md}px;
`;

export const CSSHref = styled.a`
    cursor: pointer;
    color: ${(props) => props.theme.color.secondary};
`;

export const CSSHorizontalAlign = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

import { Toast, Widget } from 'jamespot-front-business';
import { useAppDispatch, useAppSelector } from '../../../redux/store';

export const WidgetPresenceWrapperClosing = ({
    mode,
    uniqid,
    content,
}: {
    mode?: WidgetDisplayMode;
    uniqid: string;
    content: WidgetPresenceContent;
}) => {
    const intl = useIntl();
    const dispatch = useAppDispatch();

    const uri = useAppSelector((state) => Widget.selectors.selectWidgetObjectUri(state, uniqid), shallowEqual);

    const widgetObjectRights = useAppSelector(
        (state) => Widget.selectors.selectWidgetObjectRights(state, uniqid),
        shallowEqual,
    );

    const canUpdate = useMemo<boolean>(() => !!(widgetObjectRights && widgetObjectRights.update), [widgetObjectRights]);

    const handleClosing = useCallback(() => {
        if (mode === 'edit' || !canUpdate || !uri) {
            return;
        }

        const contentToUpdate = { ...content, isClosed: true };

        jamespot.widget
            .updateWidget({
                uri,
                uniqid,
                content: contentToUpdate,
                v2: true,
            })
            .then(() => dispatch(Widget.slice.actions.updateWidget({ uniqid, content: contentToUpdate })))
            .catch(() => dispatch(Toast.actions.error({ label: 'WIDGET_Presence_Error' })));
    }, [mode, uniqid, canUpdate, uri, content, dispatch]);

    return (
        <>
            {canUpdate && !content.isClosed && (
                <CSSPaddingMd>
                    <CSSHorizontalAlign>
                        <CSSHref onClick={handleClosing}>
                            {intl.formatMessage({ id: 'WIDGET_Presence_Closing' })}
                        </CSSHref>
                    </CSSHorizontalAlign>
                </CSSPaddingMd>
            )}
        </>
    );
};
